<div class="row" style="margin-top:65px">
  <h4><i class="fas fa-fw fa-key me-2"></i>Create Passkey</h4>
</div>
<div class="row mb-2" *ngIf="errorMsg != ''">
    <div class="col-12 text-center">
      <div class="alert alert-danger p-2 c_red bolder">
        {{errorMsg}}
      </div>
    </div>
</div>
<div class="row">
  <div class="col-12 col-md-4">
    <input id="passKeyName" type="text" [(ngModel)]="passkeyName" autocomplete="off"
        class="form-control form-control-sm me-3" placeholder="Enter passkey name (required)" />
  </div>
  <div class="col-12 col-md-8">
    <button class="btn btn-sm btn-dark me-2" (click)="enrollYubikey()" [disabled]="passkeyName.trim() == ''">
      <i class="fas fa-fw fa-key me-2"></i>Create Passkey
    </button>
    <button class="btn btn-sm btn-outline-dark d-none" (click)="loginTest()">
      <i class="fas fa-fw fa-chevron-right me-2"></i>Test Login
    </button>
  </div>
</div>
<div class="row mb-2">
  <div class="col-12">
    <div class="alert alert-success p-2 my-3" *ngIf="returnVal != ''">{{returnVal}}</div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <table class="table table-sm table-bordered">
      <thead>
        <tr class="text-center bolder bg_boneshadow">
          <th></th>
          <th>Passkey Location</th>
          <th>User</th>
          <th>Passkey Name</th>
          <th>Domain</th>
          <th class="d-none">Descriptor<br />Public Key</th>
          <th>Register Date</th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let x of filteredItems">
          <td class="text-center">
            <i class="fas fa-fw fa-times p-1 c_red pointer" alt="Delete Passkey" title="Delete Passkey"
               (click)="deleteKey(x.id,x.descriptorid,x.credentialstorage)"></i>
          </td>
          <td class="text-center">{{x.credentialstorage}}</td>
          <td class="text-center">{{x.username}}</td>
          <td class="text-center">{{x.passkey_name}}</td>
          <td class="text-center">{{x.passkey_domain}}</td>
          <td class="d-none">{{x.descriptorid}}<br />{{x.publickey}}</td>
          <td class="text-center">{{formatDate(x.createdat)}}</td>

        </tr>
        <tr *ngIf="registeredKeys.length === 0">
          <td colspan="6" class="text-center">No registered passkeys found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

